"use es6";

const LOADING = null;
const isLoading = (item) => item === LOADING;

export default isLoading;
